import React, { useContext, useState } from "react";
import { Button } from "react-bootstrap";
// import All_overlay from "../components/All_overlay";
import AuthProvider from "../context/AuthContext";
import { Link } from "react-router-dom";
import { FaCopy } from "react-icons/fa";
import LayoutNew from "../components/shared/LayoutNew";


function NewProfile() {
  let { logoutUser, user, profileData } = useContext(AuthProvider);
  let token = localStorage.getItem("token") || "";

  const [copied, setCopied] = useState(false);

  const handleCopy = () => {

    const text = profileData?.referral_code;
    if (!text) return;

    // Modern clipboard API
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text)
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        })
        .catch(() => fallbackCopy(text));
    } else {
      // Fallback for HTTP / mobile
      fallbackCopy(text);
    }
  };

  const fallbackCopy = (text) => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    try {
      document.execCommand("copy");
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Copy failed", err);
    }

    document.body.removeChild(textarea);
  };



  // console.log(`${import.meta.env.VITE_API_BASE_URL_MOBILE2}my-profile/mobile/${token}`,"=========")
  //   let temp =
  //     "http://sabaexch.com/my-profile/mobile/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7Il9pZCI6IjYzZjg3ZjY1NzA0N2JhYWMwMGY5MjRhZSIsInVzZXJUeXBlIjoidXNlciIsImNyZWF0ZWRCeUlkIjoiNjNmODdmMjc3MDQ3YmFhYzAwZjkyNDFhIiwiYXV0aG9yaXR5IjoxLCJlbWFpbCI6Imxva3VAbWFpbGluYXRvci5jb20iLCJ1bmlxdWVJZCI6IjU4ODkuMjk5ODQ0NTMzOTgiLCJ1c2VybmFtZSI6Imxva3V1c2VybTEiLCJwaG9uZSI6OTk5OTk5OTk5LCJmaXJzdE5hbWUiOiJsb2t1IiwibGFzdE5hbWUiOiJVc2VyIiwid2Vic2l0ZSI6bnVsbCwidGltZVpvbmUiOiJBc2lhL0tvbGthdGEiLCJiZXRzQmxvY2tlZCI6ZmFsc2UsInRvdGFsQ29pbnMiOjE3MjQxLjE2LCJjYXNpbm9Db2lucyI6MCwiYWVDYXNpbm9Vc2VySWQiOiJsb2t1dXNlcm0xIiwiZXhwb3N1cmUiOjM2OCwic3RhdHVzIjoiYWN0aXZlIn0sImlhdCI6MTY3ODM2NjA3MSwiZXhwIjoxNjc4NDUyNDcxfQ.m27dt7FG4AXsla9DxtrctNDHkRvJ1P7KeWkAEUNikII";
  //  let temp2 = "http://localhost:7002/my-profile/mobile/eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7Il9pZCI6IjYzZjg3ZjY1NzA0N2JhYWMwMGY5MjRhZSIsInVzZXJUeXBlIjoidXNlciIsImNyZWF0ZWRCeUlkIjoiNjNmODdmMjc3MDQ3YmFhYzAwZjkyNDFhIiwiYXV0aG9yaXR5IjoxLCJlbWFpbCI6Imxva3VAbWFpbGluYXRvci5jb20iLCJ1bmlxdWVJZCI6Ijc0NzMuNzE3MDM0NzQ5MTgzIiwidXNlcm5hbWUiOiJsb2t1dXNlcm0xIiwicGhvbmUiOjk5OTk5OTk5OSwiZmlyc3ROYW1lIjoibG9rdSIsImxhc3ROYW1lIjoiVXNlciIsIndlYnNpdGUiOm51bGwsInRpbWVab25lIjoiQXNpYS9Lb2xrYXRhIiwiYmV0c0Jsb2NrZWQiOmZhbHNlLCJ0b3RhbENvaW5zIjoxNzI0MS4xNiwiY2FzaW5vQ29pbnMiOjAsImFlQ2FzaW5vVXNlcklkIjoibG9rdXVzZXJtMSIsImV4cG9zdXJlIjozNjgsInN0YXR1cyI6ImFjdGl2ZSJ9LCJpYXQiOjE2NzgzNjY1MzgsImV4cCI6MTY3ODQ1MjkzOH0.1DLRYLJFsG-BzM86RbnQovqIAaQR_1xyU_qSuBv1S1c"
  //   // console.log(temp.split("/"), "temp");
  //   console.log(temp2.split("/")[3],temp2.split("/")[4], "temp2");
  return (
    <LayoutNew>
      <style>{`
        /* arrow box outline on the account menu → #1e1e1e */
        .newcssadd .menu-list a:after{ border-color:#1e1e1e !important; }
      `}</style>
      <div className="newcssadd" style={{marginTop:'55px'}}>
        {/* <All_overlay /> */}

        <div className="mian-wrap">
          <div
            className="path-wrap account-player-row"
            style={{ background: "#263e4e", lineHeight: "8vw", minHeight: "8vw" }}
          >
            <p
              className="account-id"
              style={{ fontSize: "3.46667vw", lineHeight: "8vw", margin: 0 }}
            >
              <span>{user ? user?.user?.username : ""}</span>
            </p>
          </div>

          <div className="path-wrap">
            {/* <p className="account-id hide-icon">
              <span>Referral Code: {profileData ? profileData.referral_code : ''}</span>
              <span className="time-zone d-flex"
                onClick={handleCopy}
                style={{
                  display: ' flex',
                  alignItems: 'center',
                  justifyContent: ' center'
                }}><FaCopy size={22} /></span>
            </p> */}
          </div>

          <ul className="menu-list">
            <li className="">
              <Link to="/my-profile">My Profile</Link>
            </li>

            <li className="">
              <Link to="/multiMarket">Multi Markets</Link>
            </li>

            <li className="">
              <Link to="/rolling-commission">Rolling Commission</Link>
            </li>

            <li className="">
              <Link to="/account-statement">Account Statement</Link>
            </li>

            <li className="">
              <Link to="/bets-history">Bets History</Link>
            </li>

            <li className="">
              <Link to="/profit-and-loss">Profit &amp; Loss</Link>
            </li>

            <li className="">
              <Link to="/password-history">Password History</Link>
            </li>

            <li className="">
              <Link to="/activity-logs">Activity Log</Link>
            </li>
            {/* <li className="">
            <Link
              to={`/turnover`}
            // target="_blank"
            >
              Turnover
            </Link>
          </li>
          <li className="">
            <Link
              to={`/promotions`}
            // target="_blank"
            >
              Promotions
            </Link>
          </li>

          <li className="">
            <Link
              to={`/bonus`}
            // target="_blank"
            >
              Bonus
            </Link>
          </li> */}


          </ul>

          <Button
            style={{ width: "100%" }}
            onClick={() => logoutUser()}
            id="logout"
            className="logout"
          >
            LOGOUT
          </Button>
        </div>
      </div>
    </LayoutNew>
  );
}

export default NewProfile;
